import React, { FC } from 'react'

import { IconSavingsProps } from './IconSavings.types'
import * as Styled from './styles/IconSavings.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSavings: FC<IconSavingsProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSavingsProps['size'],
  isResponsive = false,
}: IconSavingsProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='m32.98 26.182-.08.208c-.648 1.5-6.385 2.66-10.9 2.66-4.97 0-11-1.398-11-3.125 0-1.078 1.575-2.03 3.967-2.59H15'
          stroke='#0D0D0D'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M33 26.18v6.648c-1.175 1.375-6.75 2.097-11 2.097s-9.825-1-11-2.377v-6.64'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M33 30.06c1.25.538 2 1.223 2 1.965' stroke='#0D0D0D' strokeMiterlimit='10' strokeWidth='2' />
        <path
          d='M35 32.025v6.902c-1.175 1.375-6.75 2.098-11 2.098s-9.825-1-11-2.378v-5'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M35 16.81c1.25.538 2 1.223 2 1.965' stroke='#E60000' strokeMiterlimit='10' strokeWidth='2' />
        <path
          d='M37 18.775v5.902c-1.175 1.375-6.75 2.098-11 2.098s-9.825-1-11-2.378v-4.735'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M24 15.075c6.075 0 11-1.4 11-3.125 0-1.726-4.925-3.125-11-3.125s-11 1.4-11 3.125c0 1.726 4.925 3.125 11 3.125Z'
          stroke='#0D0D0D'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M35 11.95v6.902c-1.175 1.375-6.75 2.098-11 2.098s-9.825-1-11-2.378V11.95'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconSavings
